import { useState, useEffect } from "react";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  let windowType = "";
  if (width < 601) {
    windowType = "phone";
  } else if (width > 600 && width < 1181) {
    windowType = "tablet";
  } else if (width > 1181 && width < 1919) {
    windowType = "laptop";
  } else windowType = "other";
  return {
    width,
    height,
    windowType,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
